import React from 'react';
import type { FormikProps, FormikValues } from 'formik';
import { useFormikContext } from 'formik';

import CountryMultiSelectFormik from '~/components/core/Formik/CountriesMultiselectFormik/CountryMultiSelectFormik';
import useFormikChangeListener from '~/components/core/Formik/FormikChangeListener';
import StateMultiselectFormik from '~/components/core/Formik/StatesMultiselectFormik/StateMultiSelectFormik';
import { useSysconfig } from '~/components/SystemConfiguration/SystemConfigurationScreen';
import SubOrganizationMultiselectFormik from '~/components/TPA/SubOrganizations/SubOrganizationMultiselectFormik';
import { containsOneCountryWithStates, getOrganizationCountryCode } from '~/Utils';

export interface CountriesStatesSubOrgsAutocompleteFormikProps {
  shouldDisplayCountries?: boolean;
  shouldDisplayStates?: boolean;
  shouldDisplaySubOrgs?: boolean;
  countryFieldId: string;
  allCountriesFieldId?: string;
  statesFieldId: string;
  allStatesFieldId?: string;
  subOrgsFieldId: string;
  allSubOrgsFieldId?: string;
  specificSubOrgIdOptions?: number[];
}
const StatReserveUpsertDialogConditionFormik: React.FC<CountriesStatesSubOrgsAutocompleteFormikProps> = ({
  shouldDisplayCountries,
  shouldDisplayStates,
  shouldDisplaySubOrgs,
  countryFieldId,
  allCountriesFieldId,
  statesFieldId,
  allStatesFieldId,
  subOrgsFieldId,
  allSubOrgsFieldId,
  specificSubOrgIdOptions,
}) => {
  const { values, isSubmitting, setFieldValue }: FormikProps<FormikValues> = useFormikContext();
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { organization } = useSysconfig();
  const isAllCountries = values.is_all_countries;
  useFormikChangeListener({
    listenForKeys: subOrgsFieldId,
    onChange: () => {
      if (specificSubOrgIdOptions && specificSubOrgIdOptions.length === 1) {
        setFieldValue(subOrgsFieldId, [...specificSubOrgIdOptions]);
      }
    },
    runOnFirstRender: true,
  });
  return (
    <div className="grid grid-cols-1 gap-16">
      {shouldDisplayCountries ? (
        <div>
          <CountryMultiSelectFormik
            id={countryFieldId}
            statesFieldIdToResetOnChange={statesFieldId}
            allSelectedFieldId={allCountriesFieldId}
            limitTags={3}
          />
        </div>
      ) : null}
      {shouldDisplayStates ? (
        <div>
          <StateMultiselectFormik
            statesFieldId={statesFieldId}
            allSelectedFieldId={allStatesFieldId}
            disabled={
              isSubmitting ||
              isAllCountries ||
              !(shouldDisplayCountries ? containsOneCountryWithStates(values.countries) : true)
            }
            showAllInRenderedSelectedOptions
            shouldDisplayAllOption={shouldDisplaySubOrgs}
            country={
              shouldDisplayCountries && containsOneCountryWithStates(values.countries)
                ? values.countries[0]
                : getOrganizationCountryCode(organization)
            }
          />
        </div>
      ) : null}
      {shouldDisplaySubOrgs ? (
        <div>
          <SubOrganizationMultiselectFormik
            subOrganizationsFieldId={subOrgsFieldId}
            allSelectedFieldId={allSubOrgsFieldId}
            disabled={isSubmitting}
            shouldDisplayAllOption={shouldDisplayStates}
            showAllInRenderedSelectedOptions
            specificSubOrgIdOptions={specificSubOrgIdOptions}
          />
        </div>
      ) : null}
    </div>
  );
};

export default StatReserveUpsertDialogConditionFormik;
